export default __webpack_public_path__ + "static/media/caf_logo.2220d925.svg";